import React from 'react';
import { motion } from 'framer-motion';

const frameworkData = [
  {
    id: 1,
    title: "People",
    desc: "There's no single requirement here. We look at you as an individual—everything from your skills to experiences—and not every role requires a four-year degree. Each role has specific requirements listed in the job description."
  },
  {
    id: 2,
    title: "Profit",
    desc: "We drive sustainable fiscal growth by balancing short-term commercial viability with long-term ecological responsibility and ethical governance practices."
  },
  {
    id: 3,
    title: "Planet",
    desc: "Our strategic initiatives are focused on reducing environmental footprints, optimizing lifecycle processes, and promoting absolute material circularity."
  }
];

const SustainabilityFramework = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section className="w-full bg-[#FFFFFF] py-16 lg:py-24 overflow-hidden select-none text-left relative z-50">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

        <div className="w-full mb-12 lg:mb-16">
          <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora">
            The Mobikode Sustainability Framework
          </h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 xl:gap-8 w-full items-stretch"
        >
          {frameworkData.map((item) => (
            <motion.div
              key={item.id}
              variants={cardVariants}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 200, damping: 22 }}
              className="w-full bg-[#F0F0F0] p-8 lg:p-10 flex flex-col justify-between min-h-[380px] sm:min-h-[405px] rounded-none cursor-pointer relative group overflow-hidden"
            >
              <div className="absolute inset-x-0 bottom-0 h-0 bg-[#01386A] transition-all duration-500 ease-out group-hover:h-full z-10" />

              <div className="w-full flex flex-col justify-between h-full relative z-20">
                <div className="w-full flex flex-col items-start">
                  <h3 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-snug mb-4 transition-colors duration-300 group-hover:text-white">
                    {item.title}
                  </h3>
                </div>

                <div className="w-full mt-auto">
                  <p className="text-[#FFFFFF] text-[14px] lg:text-[16px] text-justify font-graphik leading-relaxed font-[500] opacity-0 max-h-0 overflow-hidden group-hover:opacity-100 group-hover:max-h-52 transition-all duration-500 ease-out">
                    {item.desc}
                  </p>

                  <div className="w-full opacity-100 max-h-20 group-hover:opacity-0 group-hover:max-h-0 overflow-hidden transition-all duration-300 ease-out">
                    <div className="flex items-center gap-2">
                      <span className="font-sora font-[600] text-[14px] sm:text-[16px] tracking-wide text-[#01386A]">
                        Read More
                      </span>
                      <span className="text-[#EA580C] font-[700] text-[14px] sm:text-[15px]">
                        &gt;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default SustainabilityFramework;